goog.provide('el8.appchart.medsHx.detailsDrawer');

goog.require('el8.uiwidget.Drawer');
goog.require('el8.template.render.medsHx');
goog.require('el8.model.base');
goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.appchart.medsHx.util');


el8.appchart.medsHx.detailsDrawer = function(spec) {
    this._isInitOrderDetails = false;
    this._isInitThreadsForMerge = false;
    this._mergeButtonSetFn = spec.mergeButtonSetFn;
    this._moveFillButtonSetFn = spec.moveFillButtonSetFn;
    this.parent.constructor.call(this, spec);
};
el8.appchart.medsHx.detailsDrawer.inheritsFrom(el8.uiwidget.Drawer);

el8.appchart.medsHx.detailsDrawer.prototype.show = function(spec) {
    spec = spec || {};

    if (spec.orderId) {
        var delay = false;
        if (!this.isShowing()) {
            this.parent.show.call(this);
        } else {
            delay = true;
        }
        this.showOrderDetails(spec.orderId, delay);

    } else if (spec.exceptThreadId) { // merge UI needs to refresh show so that sizing works
        this.parent.show.call(this);
        this.showThreadsForMerge(spec.exceptThreadId, spec.type);

    } else { // move fill UI also needs refresh show
        this.parent.show.call(this);
        this.showOrdersForMoveFill(spec.orderIds, spec.exceptOrderId);
    }
};

/**
 * Order details mode
 */
el8.appchart.medsHx.detailsDrawer.prototype._initOrderDetails = function(medOrder) {
    this._isInitOrderDetails = true;

    this._tabbedNav = new el8.uiwidget.TabbedNav();
    this._tabbedNav.init({wrapper: $('.tabbed-nav', this._container)});

    var that = this;

    // Prescription
    this._tabbedNav.addTab({
        title: 'Prescription Order',
        name: 'order',
        contentDiv: $('.order-section', this._container),
        showTabFn: function() {
            that.refreshOrderDetails();

            $(".order-section", that._container).height(
                that.getContentElt().height() -
                    ($(".tabbed-nav", that._container).outerHeight(true) || 0)
            );
        }
    });
    // Controlled Substance
    if (medOrder.getMedication().isControlled()) {
        this._tabbedNav.addTab({
            title: 'Controlled Substance Order',
            name: 'controlled',
            contentDiv: $('.order-section', this._container),
            showTabFn: function() {
                that.refreshOrderDetails();

                $(".order-section", that._container).height(
                    that.getContentElt().height() -
                        ($(".tabbed-nav", that._container).outerHeight(true) ||
                            0)
                );
            }
        });
    }

    // Refills
    this._tabbedNav.addTab({
        title: 'Refill Request',
        name: 'refill',
        contentDiv: $('.refill-section', this._container),
        showTabFn: function() {
            if (that._currOrder) {
                that._currOrder.fetchRefillRequest(function(data) {
                    $('.refill-section', that._container).html(
                        el8.template.render.rxRefillRequest.fullDetail({detail: data})
                    );
                });
            } else {
                $('.refill-section', that._container).empty();
            }
            $('.refill-section', that._container).height(
                that.getContentElt().height() -
                $('.tabbed-nav', that._container).outerHeight(true));
        }
    });
};

el8.appchart.medsHx.detailsDrawer.prototype.showOrderDetails = function(orderId, delay) {
    $('#meds-hx-drawer-order-details', this.getContainer()).show();
    this.hideThreadsForMerge();
    this.hideOrdersForMoveFill();

    var that = this;
    var doIt = function() {
        that._currOrder = el8.ptdata.medOrders.getById(orderId);  // assume is medOrder
        if (!that._isInitOrderDetails) { that._initOrderDetails(that._currOrder); }

        if (that._currOrder.getDetailsMgr()) {  // always expect to be present in meds hx
            if (that._currOrder.getDetailsMgr().getRespondedRefillRequestId()) {
                that._tabbedNav.showTabButton('refill');
            } else {
                that._tabbedNav.hideTabButton('refill');
            }
        }

        if (that._currOrder.getMedication().isControlled()) {
          that._tabbedNav.showTabButton('controlled');
          that._tabbedNav.showTab('controlled');
          that._tabbedNav.hideTabButton('order'); // note "button"
        } else {
          that._tabbedNav.showTabButton('order');
          that._tabbedNav.showTab('order');
          that._tabbedNav.hideTabButton('controlled');
        }

        $('.order-section', that._container).removeClass('dataLoading');
    };
    if (delay) {
        $('.order-section', that._container).empty().addClass('dataLoading');
        $.el8_setTimeout(doIt, 300);
    } else {
        doIt();
    }
};
el8.appchart.medsHx.detailsDrawer.prototype.refreshOrderDetails = function() {
    if (this._currOrder) {
        var map = this._currOrder.asSoyMap();
        if (this._currOrder.getFulfillmentMgr().getLatestPharmacy()) {
            map['pharmacy'] = this._currOrder.getFulfillmentMgr().getLatestPharmacy().asSoyMap();
        }

        map.isControlled = this._currOrder.getMedication().isControlled();

        $('.order-section', this._container).html(
            el8.template.render.medsHx.orderDetails({ order: map })
        );
    } else {
        $('.order-section', this._container).empty();
    }
};
el8.appchart.medsHx.detailsDrawer.prototype.hideOrderDetails = function() {
    /* Clear out order details */
    this._currOrder = null;
    $('.order-section', this._container).empty();
    $('#meds-hx-drawer-order-details', this.getContainer()).hide();
};


/**
 * Thread merge mode
 */
el8.appchart.medsHx.detailsDrawer.prototype._initThreadsForMerge = function() {
    if (this._isInitThreadsForMerge) { return; }
    this.getContainer().on('click', '.merge-thread-target',  function(e) {
        if (!$(e.target).is(':input')) {
            // Merge threads have radio btn (not checkbox)
            $(':input[type="radio"], :input[type="checkbox"]', $(this)).prop('checked', true).trigger('change');
        }
    });
    this._isInitThreadsForMerge = true;
};
el8.appchart.medsHx.detailsDrawer.prototype.showThreadsForMerge = function(
        exceptThreadId, type) {

    if (!this._isInitThreadsForMerge) { this._initThreadsForMerge(); }

    var that = this;

    this.hideThreadsForMerge(); // need to do this to reset it
    this.hideOrdersForMoveFill();
    this.hideOrderDetails();

    this._addButtonsForMerge(type);

    // TODO Don't like async=false, but for now needs to complete before pairMaker initialized
    el8.ptdata.medOrderThreads.softLoad(null, false, true, function(data) {
        el8.ptdata.medOrderThreads.create(data, true);
        that._doShowThreadsForMerge(exceptThreadId, type);
    });
};
el8.appchart.medsHx.detailsDrawer.prototype._addButtonsForMerge = function(type) {
    /* First add the buttons */
    var $drawerContent = $('.drawer-content', this._container);
    this._mergeButtonElt = $(el8.template.render.medsHx.drawerButtons());
    $drawerContent.after(this._mergeButtonElt);

    /* Now activate the button set */
    this._mergeButtonSet = this._mergeButtonSetFn(this._container, this._mergeButtonElt, type);
    this._mergeButtonSet.bindEvents();
    this._mergeButtonSet.render();

    /* Need to putz with the drawer-content's height for this to work */
    var currHeight = $drawerContent.height();
    $drawerContent.height(currHeight - this._mergeButtonElt.outerHeight(true));

};
el8.appchart.medsHx.detailsDrawer.prototype._removeButtonsForMerge = function() {
    if (this._mergeButtonElt) {
        this._mergeButtonElt.remove();
    }
};
el8.appchart.medsHx.detailsDrawer.prototype._doShowThreadsForMerge = function(
        exceptThreadId, type) {
    var drawerHeight = $('.drawer-content', this._container).height();

    var sets = el8.ptdata.medOrderThreads.getSortedSoyMaps({
        exceptId: exceptThreadId,
        includeRxDownlod: false
    });
    var isRadioBtn = (type === 'move-order');
    sets['showNewThreadTarget'] = (type === 'move-order');
    sets['isRadioBtn'] = isRadioBtn;
    sets['title'] = (type === 'move-order') ? 'Choose Med to Move to' : 'Choose Med(s) to Merge with';
    $('#meds-hx-drawer-merge', this.getContainer()).html(
        el8.template.render.medsHx.mergeView(sets)
    ).height(drawerHeight).show();

    // Bind highlighting to selecting radio/checkbox buttons
    var selectBtns = $(':input[name="mergeThreadTarget"]', this.getContainer());
    var currCheckedElt = null;
    selectBtns.on('change', function(e) {
        if (type === 'move-order') {
            if (currCheckedElt) {
                currCheckedElt.removeClass(el8.appchart.medsHx.util.SELECTED_CLASS);
            }
            currCheckedElt = $(this).closest('.merge-thread-target');
            currCheckedElt.addClass(el8.appchart.medsHx.util.SELECTED_CLASS);
        } else {
            var elt = $(this).closest('.merge-thread-target');
            if ($(this).is(':checked')) {
                elt.addClass(el8.appchart.medsHx.util.SELECTED_CLASS);
            } else {
                elt.removeClass(el8.appchart.medsHx.util.SELECTED_CLASS);
            }
        }
    });
};
el8.appchart.medsHx.detailsDrawer.prototype.hideThreadsForMerge = function() {
    this._removeButtonsForMerge();
    $('#meds-hx-drawer-merge', this.getContainer()).empty().hide();
};


/**
 * Move fill mode
 */
el8.appchart.medsHx.detailsDrawer.prototype._initOrdersForMoveFill = function() {
    if (this._isInitOrdersForMoveFill) { return; }
    this.getContainer().on('click', '.move-fill-target',  function(e) {
        if (!$(e.target).is(':input')) {
            $(':input[type="radio"]', $(this)).prop('checked', true).trigger('change');
        }
    });
    this._isInitOrdersForMoveFill = true;
};
el8.appchart.medsHx.detailsDrawer.prototype.showOrdersForMoveFill = function(orderIds,
        exceptOrderId) {
    if (!this._isInitOrdersForMoveFill) { this._initOrdersForMoveFill(); }

    this.hideOrdersForMoveFill();
    this.hideThreadsForMerge();
    this.hideOrderDetails();

    this._addButtonsForMoveFill();
    this._doShowOrdersForMove(orderIds, exceptOrderId);
};
el8.appchart.medsHx.detailsDrawer.prototype._addButtonsForMoveFill = function() {
    /* First add the buttons */
    var $drawerContent = $('.drawer-content', this._container);
    this._moveFillButtonElt = $(el8.template.render.medsHx.drawerButtons());
    $drawerContent.after(this._moveFillButtonElt);

    /* Now activate the button set */
    this._moveFillButtonSet = this._moveFillButtonSetFn(this._container, this._moveFillButtonElt);
    this._moveFillButtonSet.bindEvents();
    this._moveFillButtonSet.render();

    /* Need to putz with the drawer-content's height for this to work */
    var currHeight = $drawerContent.height();
    $drawerContent.height(currHeight - this._moveFillButtonElt.outerHeight(true));
};
el8.appchart.medsHx.detailsDrawer.prototype._removeButtonsForMoveFill = function() {
    if (this._moveFillButtonElt) {
        this._moveFillButtonElt.remove();
    }
};
el8.appchart.medsHx.detailsDrawer.prototype._doShowOrdersForMove = function(orderIds,
        exceptOrderId) {
    var drawerHeight = $('.drawer-content', this._container).height();

    var medOrders = [];
    for (var i=0; i<orderIds.length; i++) {
        if (el8.model.idToModelClass(orderIds[i]) === 'MedOrder') {
            var medOrder = el8.ptdata.medOrders.getById(orderIds[i]);
            if (!medOrder.isRxDownload()) {
                medOrders.push(medOrder);
            }
        }
    }

    $('#meds-hx-drawer-move-fill', this.getContainer()).html(
        el8.template.render.medsHx.moveFillView({
            title: 'Choose order to move fill to',
            orders: medOrders.map(function(a) {
                return a.asSoyMap();
            }),
            exceptOrderId: exceptOrderId
        })
    ).height(drawerHeight).show();

    // Bind highlighting to selecting radio/checkbox buttons
    var selectBtns = $(':input[name="moveFillTarget"]', this.getContainer());
    var currCheckedElt = null;
    selectBtns.on('change', function(e) {
        if (currCheckedElt) {
            currCheckedElt.removeClass(el8.appchart.medsHx.util.SELECTED_CLASS);
        }
        currCheckedElt = $(this).closest('.move-fill-target');
        currCheckedElt.addClass(el8.appchart.medsHx.util.SELECTED_CLASS);
    });
};
el8.appchart.medsHx.detailsDrawer.prototype.hideOrdersForMoveFill = function() {
    this._removeButtonsForMoveFill();
    $('#meds-hx-drawers-move-fill', this.getContainer()).empty().hide();
};
